<div class="row">
  <div class="col-md-12 text-center">
<!--    <img src="/assets/img/preloader.png" [ngStyle]="{ width: size == 'sm' ? '32px' : 'auto' }">-->
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</div>
